export default __webpack_public_path__ + "4a9a50f613ed7328b5ae1ff2e039c954.png";